import React from 'react';
import {NavBar} from './navbar';
import {MainChart} from './dashboard';
import {State} from './state';
import {Events} from './events';
import {About} from './about';
import {Profile} from './profile';

import {apiVariables} from '../utils/variables';
import {BrowserRouter as Router, Route} from 'react-router-dom';


//Imported styles
import '../index.css';
import '../main.css';
import '../includes/bootstrap-3.3.7/css/bootstrap.min.css';
/* eslint eqeqeq: "off"*/





export class Home extends React.Component{
    constructor(props){
        super(props);
        this.state = { organizations: [], CurrentOrganization: "", display: "dashboard"};
        this.updateSelected = this.updateSelected.bind(this);
        this.changeDisplay = this.changeDisplay.bind(this);
    }
    updateSelected(organization){
        this.setState({CurrentOrganization: organization});
        localStorage.setItem('CurrentOrganization', organization);
        window.location.reload();
    }
    componentWillMount(){
        this.loadOrganizations();
    }
    loadOrganizations(){
        console.log(apiVariables.apiLink + 'solutionmonitor/overview/organizationList?username=' + encodeURIComponent(this.props.username))
        fetch(apiVariables.apiLink + 'solutionmonitor/overview/organizationList?username=' + encodeURIComponent(this.props.username), { 
            method: 'get',
            credentials: apiVariables.credentials,
            headers: apiVariables.apiHeader
        })
        .then((response) => response.json())
        .then((responseJson) => {
            if(responseJson.document === undefined || responseJson.document.organizations === undefined){
               this.setState({CurrentOrganization: null})
            }
            else{
                this.setState({organizations: responseJson.document.organizations});
                if((this.state.CurrentOrganization === "" && localStorage.getItem('CurrentOrganization') == null) || responseJson.document.organizations.includes(localStorage.getItem('CurrentOrganization')) === true){
                    localStorage.setItem('CurrentOrganization', responseJson.document.organizations[0].organization);
                    this.setState({CurrentOrganization: responseJson.document.organizations[0].organization});
                }
                else{
                    this.setState({CurrentOrganization: localStorage.getItem('CurrentOrganization')});
                }
            }
            });
    }
    changeDisplay(display){
        this.setState({display: display});
    }
    render(){
        if(this.state.CurrentOrganization !== "")
        {   return(
            <Router>
                <div>
                    <NavBar updateSelected={this.updateSelected} organizations={this.state.organizations} signout={this.props.signout} username={this.props.username} CurrentOrganization={this.state.CurrentOrganization}/>
                    <Route  exact path="/profile" render={(props)=> <Profile CurrentOrganization={this.state.CurrentOrganization} username={this.props.username} organizations={this.state.organizations}/>}/>
                    {this.state.CurrentOrganization !== null ? <div className="container">
                        <Route  exact path="/" render={(props)=> <MainChart CurrentOrganization={this.state.CurrentOrganization}/>}/>
                        <Route  path="/state/:searchTerm?" render={(props)=> <State CurrentOrganization={this.state.CurrentOrganization} urlProps={props} username={this.props.username}/>}/>
                        <Route  ute exact path="/events" render={(props)=> <Events CurrentOrganization={this.state.CurrentOrganization}/>}/>
                        <Route  exact path="/about" render={(props)=> <About CurrentOrganization={this.state.CurrentOrganization}/>}/>
                         </div> : <div className="container"><h1>No assigned organization</h1></div>}
                </div>
            </Router>)
        }
        else{
           
            return ( 
                <div></div>);
        }
    }
}




  


// WEBPACK FOOTER //
// ./src/pages/home.js